
import server from '../../public/server/server'
const districtApi = {
    //----------------------区域管理-----------------------------------
    queryListByPage:server.requestPath +  '/sysArea/queryListByPage', // 获取区域列表
    findById:server.requestPath +  '/sysArea/findById', // 获取区域详情
    save:server.requestPath +  '/sysArea/save', // 保存区域信息
    saveUnit:server.requestPath +  '/sysArea/saveUnit', // 配置单位
    findUnitById:server.requestPath +  '/sysArea/findUnitById', // 获取当前区域的配置单位信息
    liveIoView:server.requestPath +  '/sysArea/liveIoView', // 获取当前区域终端配置
    liveIo:server.requestPath +  '/sysArea/liveIo', // 保存
    open:server.requestPath +  '/sysArea/open', // 区域开通
    report:server.requestPath +  '/sysArea/report', // 是否终止上报
    saveHotArea:server.requestPath +  '/sysArea/saveHotArea', // 热区添加
    findHotArea:server.requestPath +  '/sysArea/findHotArea', // 区域管理-----区域选择--热区-----根据区域id反显
    queryCenterByHotArea:server.requestPath +  '/sysArea/queryCenterByHotArea', // 区域管理-----区域选择--热区-----根据区域id反显
    delHotArea:server.requestPath +  '/sysArea/delHotArea', // 区域管理-----区域选择--热区-----删除热区
	savePriority:server.requestPath +  '/sysArea/savePriority', // 区域管理-----区域选择--热区-----热区优先级设置
}
const cameraApi={
    //----------------------摄像机管理-----------------------------------
    queryListByPage:server.requestPath +  '/camera/queryListByPage', // 获取摄像机列表
    importCameraSyn:server.requestPath +  '/camera/import/cameraSyn', // 导入摄像头信息
    exportCameraSyn:server.requestPath +  '/camera/export/cameraSyn', // 导出摄像头信息areaId
    exportFindLiveUrl:server.requestPath +  '/camera/export/findLiveUrl', // 导出摄像头直播地址
    saveByIp:server.requestPath +  '/camera/saveByIp', // 编辑/新增
    batchUp:server.requestPath +  '/camera/batchUp', // 批量编辑
    findById:server.requestPath +  '/camera/findById', // 查看详情
    deleteCamera:server.requestPath +  '/camera/deleteCamera', // 删除
    importCameraSynList:server.requestPath +  '/camera/import', // 导入
    template:server.requestPath +  '/camera/down/template', // 下载导入模板
    templateDesc:server.requestPath +  '/camera/down/templateDesc', // 下载导入模板参数说明areaId
    rtspList:server.requestPath +  '/rtsp/list', // 下载导入模板参数说明areaId
    codeAndItem:server.requestPath +  '/sysCode/codeAndItem', // 获取下拉选择列表，所有
    queryList:server.requestPath +  '/sysPlatform/queryList', // 获取流媒体信息
    findLiveUrl:server.requestPath +  '/camera/findLiveUrl', // 批量获取地址
}
const setSystemApi={
    itemQueryListByPage:server.requestPath +  '/sysCode/item/queryListByPage', // 编码 item-----获取编码Item表
    sysCodeFindById:server.requestPath +  '/sysCode/item/findById', // 编码 item -----查询编码详情
    itemSaveSysCode:server.requestPath +  '/sysCode/item/save', // 编码-----增加/编辑
    itemDelSysCode:server.requestPath +  '/sysCode/item/del', // 编码-----删除
    itemQueryByCodeValue:server.requestPath +  '/sysCode/item/queryByCodeValue', //获取所有的Item
    queryByCodeValue:server.requestPath +  '/sysCode/queryByCodeValue', // 获取所有的Item
    delSysCode:server.requestPath +  '/sysCode/del', // 编码-----删除
    saveSysCode:server.requestPath +  '/sysCode/save', // 编码-----增加/编辑
    queryListByPage:server.requestPath +  '/sysCode/queryListByPage', // 编码 item -----查询编码详情
    findById:server.requestPath +  '/sysCode/findById', // 编码 item -----查询编码详情
    // 版本控制
    queryList:server.requestPath +  '/version/queryList',//版本管理---- 获取版本列表
    saveQueryList:server.requestPath +  '/version/save'// 版本管理---- 增加/编辑

}


const dahuaApi={
    queryListByUserId:server.requestPath+ '/dahua/list',//指挥中心列表----绑定第三方用户--列表
    delDahua:server.requestPath+ '/dahua/del',//指挥中心列表----绑定第三方用户--解绑
    saveDahua:server.requestPath+ '/dahua/save',//指挥中心列表----绑定第三方用户--保存或修改
    monitorAddress:server.requestPath+ '/dahua/monitorAddress', //系统资源---区域管理--监控平台地址
    detail:server.requestPath+ '/dahua/detail'  //详情 用于张瑞提供的盒子
}

export {
    districtApi,
	cameraApi,
    setSystemApi,
    dahuaApi
}
